import React from 'react';

export interface ReportsContextType {
  // Active (non-archived) reports. Does not include reports with isHidden: true.
  allReports: ReportType[];
  // Reports with isHidden: true. Only exposed for the staff-only Archived view.
  archivedReports: ReportType[];
  availableReports: ReportType[];
  isLoading: boolean;
}
const ReportsContext = React.createContext<ReportsContextType>({
  allReports: [],
  archivedReports: [],
  availableReports: [],
  isLoading: true,
});

export default ReportsContext;
